import React from 'react';
import { Check, X } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
import { motion } from 'framer-motion';
export function PackComparison() {
  const tableData = [{
    sit: 'Llegás a un caso complejo que no encaja en ningún patrón',
    sin: 'Improvisás o le preguntás al tutor',
    con: '30 casos complejos resueltos con razonamiento paso a paso'
  }, {
    sit: 'Necesitás preparar un examen de razonamiento clínico',
    sin: 'Repasás teoría suelta',
    con: 'Casos organizados por región y complejidad'
  }, {
    sit: 'Tu tutor te pide que presentes el caso con hipótesis diferencial',
    sin: 'No sabés por dónde empezar',
    con: 'Formato de presentación clínica incluido'
  }, {
    sit: 'Necesitás practicar el informe kinésico',
    sin: 'Usás un modelo genérico',
    con: '15 informes modelo completos ya redactados'
  }, {
    sit: 'Querés diferenciarte en el internado',
    sin: 'Hacés lo que hacen todos',
    con: 'Razonamiento clínico avanzado que se nota desde el primer día'
  }];
  const includes = ['30 casos clínicos adicionales de complejidad alta', 'Casos post-quirúrgicos', 'Casos con patologías combinadas', 'Casos con factores psicosociales relevantes', '15 informes kinésicos modelo completamente redactados', 'Formato de presentación clínica para el internado', 'Guía de retorno al deporte y actividad física', 'Protocolo de evaluación del paciente crónico'];
  return <AnimatedSection className="bg-navy-900 border-y border-dark-border" data-id="element-168">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-center mb-10 sm:mb-12 leading-tight" data-id="element-170">
          🩺 ¿QUÉ AGREGA EL PACK RAZONAMIENTO AVANZADO?
        </h2>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5,
        duration: 1
      }} className="mb-3 sm:mb-4 text-xs sm:text-sm text-gold md:hidden text-center flex items-center justify-center gap-2" data-id="element-171">
          ← Scroll to see full table →
        </motion.div>

        <div className="overflow-x-auto pb-6 mb-10 sm:mb-12 scrollbar-hide" data-id="element-172">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-173">
            <thead data-id="element-174">
              <tr data-id="element-175">
                <th className="text-left p-3 sm:p-4 border-b border-dark-border text-gray-400 font-medium text-sm sm:text-base w-2/5" data-id="element-176">
                  Situación en la práctica o internado
                </th>
                <th className="text-left p-3 sm:p-4 border-b border-dark-border text-gray-400 font-medium text-sm sm:text-base w-1/4" data-id="element-177">
                  <div className="flex items-center gap-2 text-red-400" data-id="element-178">
                    <X size={16} data-id="element-179" /> Sin Pack
                  </div>
                </th>
                <th className="text-left p-3 sm:p-4 border-b border-gold text-gold font-bold text-sm sm:text-base w-auto bg-gold/5 rounded-t-lg" data-id="element-180">
                  <div className="flex items-center gap-2" data-id="element-181">
                    <Check size={16} data-id="element-182" /> Con Pack
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-183">
              {tableData.map((row, idx) => <tr key={idx} className="hover:bg-white/[0.02] transition-colors" data-id="element-184">
                  <td className="p-3 sm:p-4 border-b border-dark-border/50 text-white font-medium text-sm sm:text-base" data-id="element-185">
                    {row.sit}
                  </td>
                  <td className="p-3 sm:p-4 border-b border-dark-border/50 text-gray-400 text-sm sm:text-base" data-id="element-186">
                    {row.sin}
                  </td>
                  <td className="p-3 sm:p-4 border-b border-dark-border/50 text-gold-light bg-gold/5 text-sm sm:text-base" data-id="element-187">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="bg-dark-card border border-gold/30 rounded-xl p-6 sm:p-8 max-w-3xl mx-auto" data-id="element-188">
          <h3 className="text-lg sm:text-xl font-heading font-bold text-white mb-5 sm:mb-6 text-center" data-id="element-189">
            El Pack incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-3 sm:gap-4" data-id="element-190">
            {includes.map((item, idx) => <div key={idx} className="flex items-start gap-2 sm:gap-3" data-id="element-191">
                <div className="mt-0.5 sm:mt-1 bg-gold/20 p-1 rounded-full flex-shrink-0" data-id="element-192">
                  <Check size={14} className="text-gold" data-id="element-193" />
                </div>
                <span className="text-sm sm:text-base text-gray-300 leading-relaxed" data-id="element-194">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </AnimatedSection>;
}